<template lang="pug">
  .deals(v-if="$rogue.site.code !== 'APO'")
    rogue-link.badge(to="/order-process" v-if="$rogue.site.code === 'CAN'") No Fees At Delivery!
      Icon(name="arrow-right" fill="white")
    rogue-link.badge(to="/shipping-promotions" v-else)
      | {{__('Daily Shipping Deals')}}
      Icon(name="arrow-right" fill="white")
    br
    .deal-slides(tabindex="0" ref="deal-slides")
      rogue-link.slide.show(
        tabindex="-1"
        to="/free-shipping"
        v-if="['USA','EUR','AUS','GBR'].includes($rogue.site.code)"
      )
        div(v-html="freeShippingHtml")
      rogue-link.slide(
        tabindex="-1"
        to="/shipping-promotions"
        v-if="['EUR','GBR'].includes($rogue.site.code)"
      )
        div(v-html="rigShipsFreetml")
      rogue-link.slide(
        tabindex="-1"
        to="/shipping-promotions"
        v-if="['USA'].indexOf($rogue.site.code) !== -1"
      )
        div(v-html="fxTrainerShipFreeHtml")
      rogue-link.slide(
        tabindex="-1"
        to="/shipping-promotions"
        v-if="['USA'].indexOf($rogue.site.code) !== -1"
      )
        div(v-html="fiveKShipFreeHtml")
      rogue-link.slide(
        tabindex="-1"
        to="/3-ships-free"
        v-if="['USA','EUR','AUS','GBR'].includes($rogue.site.code)"
      )
        div(v-html="threeShipsFreeHtml")
      rogue-link.slide.show(
        tabindex="-1"
        to="/order-process"
        v-if="['CAN'].indexOf($rogue.site.code) !== -1"
      )
        div(v-html="orderProcessHtml")
</template>
<script setup lang="ts">
import { useRogue } from '@/js/services/Rogue'

const rogue = useRogue()

const freeShippingHtml = rogue.__('<span class=\"red\">FREE SHIPPING</span> ON SELECT ITEMS <span class=\"link\">Shop Now</span>')
const rigShipsFreetml = rogue.__('BUY A RIG* AND YOUR ENTIRE ORDER <span class=\"red\">SHIPS FREE</span> <span class=\"link\">See Details</span>')
const fxTrainerShipFreeHtml = rogue.__('BUY A FUNCTIONAL TRAINER AND YOUR ENTIRE ORDER <span class=\"red\">SHIPS FREE</span> <span class=\"link\">See Details</span>')
const fiveKShipFreeHtml = rogue.__('ORDERS OF <span class=\"red\">$5K SHIP FREE</span> <span class=\"link\">See Details</span>')
const threeShipsFreeHtml = rogue.__('BUY 3 OR MORE <span class=\"red\">3 SHIPS FREE</span> AND THEY SHIP FOR FREE <span class=\"link\">Shop Now</span>')
const orderProcessHtml = rogue.__('Ships from USA & Rogue Pays Customs Fees <span class=\"link\">Learn More</span>')
</script>
<style lang="scss">
// Global styles necessary to style spans inside of translate fns
.deals > .deal-slides > .slide {
  .red {
    // color-red is 4.49:1 on the black header, just under WCAG AA for 12px text; red-light is 5.18:1
    color: $color-red-light;
    font-weight: bold;
    white-space: nowrap;
  }

  .link {
    color: $color-white;
    white-space: nowrap;
  }
}

</style>
<style lang="scss" scoped>

.deals {
  display: none;
  font-size: $size-xxs;
  flex-basis: 30%;
  max-width: 300px;

  @include all-desktop() {
    display: block;
    min-width: 300px;
    max-width: initial;
  }
}

.deal-slides {
  position: relative;
  margin: 0 auto;
  height: 28px;
}

.slide {
  font-family: $font-sans-serif;
  font-size: $size-xxs;
  color: $color-white;
  text-decoration: none;
  font-weight: $weight-light;
  letter-spacing: .09375em;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  transition: opacity 1s ease;

  &.show {
    opacity: 1;
    pointer-events: all;
  }
}

.badge {
  background-color: $color-red;
  display: inline-flex;
  align-items: center;
  padding: 4px;
  margin-bottom: 4px;
  text-decoration: none;
  color: $color-white;
  font-family: $font-sans-serif;
  font-size: $size-xxs;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0.1em;

  .icon {
    width: 8px;
    height: 8px;
    margin-left: $space-xxs;
  }
}

</style>
